export default import.meta.ROLLDOWN_FILE_URL_DzxfgPTHZFoHEJe8Cn5N0g